export default __webpack_public_path__ + "static/media/solusdt.149305d7.png";